import type { ComponentType, ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material';

import type { tagColors } from 'modules/common/components/MUI/Tag';

export enum RichStepType {
    Numbered = 'numbered',
    Icon = 'icon',
}

interface BaseStep {
    title: string;
    description?: ReactNode;
    tag?: {
        label: string;
        color: keyof typeof tagColors;
    };
}

export interface NumberedStep extends BaseStep {
    type: RichStepType.Numbered;
    number: number;
}

export interface IconStep extends BaseStep {
    type: RichStepType.Icon;
    icon: ComponentType<{ sx?: SxProps<Theme> }>;
}

export type RichStep = NumberedStep | IconStep;

export interface RichStepListProps {
    steps: RichStep[];
}
